import React from "react";
import { useHistory } from "react-router-dom";

const companiesList = [
  {
    name: "قبض همراه اول",
    icon: require("../../assets/images/MCI.png"),
    path: `/Payment/Mobile`,
    companyId: 4,
  },
  {
    name: "قبض تلفن",
    icon: require("../../assets/images/Telephone.png"),
    path: `/Payment/Telephone`,
    companyId: 5,
  },
  {
    name: "قبض آب",
    icon: require("../../assets/images/Water.png"),
    path: `/Payment/Water`,
    companyId: 1,
    big: true,
  },
  {
    name: "قبض گاز",
    icon: require("../../assets/images/Gas.png"),
    path: `/Payment/Gas`,
    companyId: 2,
  },
  {
    name: "قبض برق",
    icon: require("../../assets/images/Electricity.png"),
    path: `/Payment/Electricity`,
    companyId: 3,
  },
  {
    name: "قبض ایرانسل",
    icon: require("../../assets/images/Irancell.png"),
    path: `/Payment/Mobile`,
    companyId: 6,
  },
];

const Company = ({
  name,
  Icon,
  className,
  onClick,
  showName,
  selected,
  big,
}) => {
  return (
    <div
      className={showName || selected ? className : `${className} grayscale`}
      onClick={onClick}
    >
      {<img src={Icon} alt={""} />}
      {showName && <span>{name}</span>}
    </div>
  );
};

const Companies = ({ name, onClick, selectedId }) => {
  const history = useHistory();
  const Click = (i) => {
    onClick
      ? onClick(i.companyId)
      : history.push({
          pathname: i.path,
        });
  };
  return (
    <div
      className={name ? "companiesDiv" : "companiesDiv companiesDivUsage"}
      id="companiesDiv"
    >
      {companiesList.map((i, index) => {
        return (
          <Company
            big={i.big}
            selected={selectedId === i.companyId}
            onClick={() => Click(i)}
            name={i.name}
            Icon={i.icon}
            key={`#company${index}${i.name}`}
            showName={name}
            className={`company${index}`}
          />
        );
      })}
    </div>
  );
};

export default Companies;
